// Code By Webdevtrick ( https://webdevtrick.com )
import $ from "jquery";

$.fn.lastWord = function() {
  var text = this.text().trim().split(" ");
  var last = text.pop();
  this.html(text.join(" ") + (text.length > 0 ? " <span class='last-word'>" + last + "</span>" : last));
};
 
$(".menu-item--orange a").lastWord();